import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { UmbraLink } from '@/components/generals/umbra-link'
import { useMenu } from '@/components/generals/menu-context'

export const SiteHeader: FC = (): ReactNode => {
    const { open, setOpen } = useMenu()

    return (
        <header
            className={cn(
                'pointer-events-none fixed inset-x-0 top-0 z-40 flex items-start justify-between px-6 pt-6 transition-opacity duration-500 md:px-10 md:pt-8',
                open && 'opacity-0'
            )}
        >
            <a
                href='#main'
                className='label-caps pointer-events-auto absolute left-6 top-14 -translate-y-24 bg-void px-3 py-2 text-flare focus:translate-y-0 md:left-10'
            >
                Skip to content
            </a>

            <UmbraLink
                href='/'
                aria-label='VOIDEN, back to the start'
                className='label-caps pointer-events-auto text-[0.75rem] tracking-[0.42em] text-flare transition-opacity duration-500 hover:opacity-70'
            >
                VOIDEN
            </UmbraLink>

            <button
                type='button'
                onClick={() => setOpen(true)}
                aria-haspopup='dialog'
                aria-expanded={open}
                tabIndex={open ? -1 : 0}
                className='label-caps link-line pointer-events-auto text-flare'
            >
                Menu
            </button>
        </header>
    )
}
